import React, { useState } from 'react';
import { images } from '../../../assets/images'
import { Tab, Tabs } from 'react-bootstrap';
import Slider from 'react-slick';


function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <i className="far fa-angle-right"></i>
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <i className="far fa-angle-left"></i>
        </div>
    );
}

function LatestWork() {
    const [key, setKey] = useState('web-development');

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
    };

    return (
        <div className="work_section_wrapper">
            <Tabs
                id="latestWorkTabs"
                activeKey={key}
                onSelect={(k) => setKey(k)}
            >
                <Tab eventKey="web-development" title="Web Development">
                    <div className="work_items">
                        <Slider {...settings}>
                            <div className="work_item">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                        <div className="work_img embed-responsive embed-responsive-16by9">
                                            <img src={images.process2} alt="..." className="img-fluid d-block mx-auto embed-responsive-item" />
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                        <div className="work_content">
                                            <h4 className="work_item_title">Lorem ipsum dolor sit, amet consectetur adipisicing.</h4>
                                            <div className="cms_section">
                                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ad tenetur officiis maxime, ut expedita ipsa deserunt quod non libero hic soluta iusto nam quibusdam eveniet quisquam dolor asperiores quos aut voluptates! Nobis, eveniet doloribus facere nihil suscipit commodi rem nemo. ectetur adipisicing elit. Ad tenetur officiis maxime, ut expedita ipsa deserunt quod non libero hic soluta iusto nam quibusdam eveniet quisquam dolor asperiores quos aut voluptates! Nobis, eveniet doloribus facere nihil suscipit commodi rem ne.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="work_item">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                        <div className="work_img embed-responsive embed-responsive-16by9">
                                            <img src={images.process2} alt="..." className="img-fluid d-block mx-auto embed-responsive-item" />
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                        <div className="work_content">
                                            <h4 className="work_item_title">Lorem ipsum dolor sit, amet consectetur adipisicing.</h4>
                                            <div className="cms_section">
                                                <p>Lorem ipsum dolor sit amet consectetur ectetur adipisicing elit. Ad tenetur officiis maxime, ut expedita ipsa deserunt quod non libero hic soluta iusto nam quibusdam eveniet quisquam dolor asperiores quos aut voluptates! Nobis, eveniet doloribus facere nihil suscipit commodi rem ne adipisicing elit. Ad tenetur officiis maxime, ut expedita ipsa deserunt quod non libero hic soluta iusto nam quibusdam eveniet quisquam dolor asperiores quos aut voluptates! Nobis, eveniet doloribus facere nihil suscipit commodi rem nemo.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </Tab>
                <Tab eventKey="mobile-app-development" title="Mobile App development">
                <div className="work_items">
                        <Slider {...settings}>
                            <div className="work_item">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                        <div className="work_img embed-responsive embed-responsive-16by9">
                                            <img src={images.process2} alt="..." className="img-fluid d-block mx-auto embed-responsive-item" />
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                        <div className="work_content">
                                            <h4 className="work_item_title">Lorem ipsum dolor sit, amet consectetur adipisicing.</h4>
                                            <div className="cms_section">
                                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ad tenetur officiis maxime, ut expedita ipsa deserunt quod non libero hic soluta iusto nam quibusdam eveniet quisquam dolor asperiores quos aut voluptates! Nobis, eveniet doloribus facere nihil suscipit commodi rem nemo. ectetur adipisicing elit. Ad tenetur officiis maxime, ut expedita ipsa deserunt quod non libero hic soluta iusto nam quibusdam eveniet quisquam dolor asperiores quos aut voluptates! Nobis, eveniet doloribus facere nihil suscipit commodi rem ne.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="work_item">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                        <div className="work_img embed-responsive embed-responsive-16by9">
                                            <img src={images.process2} alt="..." className="img-fluid d-block mx-auto embed-responsive-item" />
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                        <div className="work_content">
                                            <h4 className="work_item_title">Lorem ipsum dolor sit, amet consectetur adipisicing.</h4>
                                            <div className="cms_section">
                                                <p>Lorem ipsum dolor sit amet consectetur ectetur adipisicing elit. Ad tenetur officiis maxime, ut expedita ipsa deserunt quod non libero hic soluta iusto nam quibusdam eveniet quisquam dolor asperiores quos aut voluptates! Nobis, eveniet doloribus facere nihil suscipit commodi rem ne adipisicing elit. Ad tenetur officiis maxime, ut expedita ipsa deserunt quod non libero hic soluta iusto nam quibusdam eveniet quisquam dolor asperiores quos aut voluptates! Nobis, eveniet doloribus facere nihil suscipit commodi rem nemo.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </Tab>
                <Tab eventKey="digital-marketing" title="Digital Marketing">
                <div className="work_items">
                        <Slider {...settings}>
                            <div className="work_item">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                        <div className="work_img embed-responsive embed-responsive-16by9">
                                            <img src={images.process2} alt="..." className="img-fluid d-block mx-auto embed-responsive-item" />
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                        <div className="work_content">
                                            <h4 className="work_item_title">Lorem ipsum dolor sit, amet consectetur adipisicing.</h4>
                                            <div className="cms_section">
                                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ad tenetur officiis maxime, ut expedita ipsa deserunt quod non libero hic soluta iusto nam quibusdam eveniet quisquam dolor asperiores quos aut voluptates! Nobis, eveniet doloribus facere nihil suscipit commodi rem nemo. ectetur adipisicing elit. Ad tenetur officiis maxime, ut expedita ipsa deserunt quod non libero hic soluta iusto nam quibusdam eveniet quisquam dolor asperiores quos aut voluptates! Nobis, eveniet doloribus facere nihil suscipit commodi rem ne.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="work_item">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                        <div className="work_img embed-responsive embed-responsive-16by9">
                                            <img src={images.process2} alt="..." className="img-fluid d-block mx-auto embed-responsive-item" />
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                        <div className="work_content">
                                            <h4 className="work_item_title">Lorem ipsum dolor sit, amet consectetur adipisicing.</h4>
                                            <div className="cms_section">
                                                <p>Lorem ipsum dolor sit amet consectetur ectetur adipisicing elit. Ad tenetur officiis maxime, ut expedita ipsa deserunt quod non libero hic soluta iusto nam quibusdam eveniet quisquam dolor asperiores quos aut voluptates! Nobis, eveniet doloribus facere nihil suscipit commodi rem ne adipisicing elit. Ad tenetur officiis maxime, ut expedita ipsa deserunt quod non libero hic soluta iusto nam quibusdam eveniet quisquam dolor asperiores quos aut voluptates! Nobis, eveniet doloribus facere nihil suscipit commodi rem nemo.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </Tab>
            </Tabs>
        </div>
    );
}

export { LatestWork };
